import {styled, Tab, Box} from '../../../ui-library';

export const TabTitle = styled(Tab)`
    justify-content: space-around;
    width: 50%;
    max-width: 800px;
`;

export const TabBox = styled(Box)`
    min-width: 900px;
`;
